import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import QRCode from "qrcode";

// Pantalla de enrolamiento de Google Authenticator.
// El SecretCode viene de AssociateSoftwareToken (Cognito); aqui solo se arma la
// URI otpauth:// y se dibuja el QR en el navegador. El secreto nunca sale del
// cliente ni se guarda en ningun lado.
const ISSUER = "PORTAL EBG";

const MfaSetup = ({ secretCode, username }) => {
  const [qr, setQr] = useState(null);
  const [qrError, setQrError] = useState(false);

  useEffect(() => {
    if (!secretCode) return;
    const uri = `otpauth://totp/${encodeURIComponent(
      ISSUER
    )}:${encodeURIComponent(username)}?secret=${secretCode}&issuer=${encodeURIComponent(
      ISSUER
    )}`;
    // Se usa toString/svg y no toDataURL: la compilacion de navegador de
    // "qrcode" (la que empaqueta webpack) exige un <canvas> como primer
    // argumento en toDataURL y falla con "You need to specify a canvas
    // element". toString es JS puro y se comporta igual en node y navegador.
    QRCode.toString(uri, {
      type: "svg",
      width: 400,
      margin: 1,
      color: { dark: "#0b141d", light: "#ffffff" },
    })
      .then((svg) =>
        setQr(`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`)
      )
      .catch((error) => {
        console.log(error);
        setQrError(true);
      });
  }, [secretCode, username]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.75 }}>
      <Box
        sx={{
          alignSelf: "center",
          p: 1.5,
          bgcolor: "#ffffff",
          borderRadius: "12px",
          lineHeight: 0,
          width: 196,
          height: 196,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {qr && (
          <Box
            component="img"
            src={qr}
            alt="Código QR para Google Authenticator"
            sx={{ width: "100%", height: "100%" }}
          />
        )}
        {!qr && !qrError && <CircularProgress size={28} />}
        {qrError && (
          <Typography
            sx={{ fontSize: 12, color: "#0b141d", textAlign: "center", px: 1 }}
          >
            No se pudo dibujar el código. Usa la clave de abajo.
          </Typography>
        )}
      </Box>

      <Box
        component="ol"
        sx={{
          m: 0,
          pl: 2.5,
          fontSize: 13,
          color: "#8ba3b8",
          lineHeight: 1.7,
          "& li::marker": { color: "#4da3d8", fontWeight: 700 },
        }}
      >
        <li>Abre Google Authenticator en tu teléfono.</li>
        <li>
          Toca <b style={{ color: "#a9bfd1" }}>+</b> y elige{" "}
          <b style={{ color: "#a9bfd1" }}>Escanear código QR</b>.
        </li>
        <li>Escribe abajo los 6 dígitos que te muestre la aplicación.</li>
      </Box>

      {/* La clave se muestra siempre: si el QR no se dibuja, el enrolamiento
          no debe quedar sin salida. En Google Authenticator es
          "+" -> "Introducir clave de configuracion". */}
      <Typography sx={{ fontSize: 12, color: "#5f7a91" }}>
        ¿No puedes escanearlo? Escribe esta clave en la app:
      </Typography>
      <Typography
        sx={{
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 13,
          letterSpacing: 1.5,
          wordBreak: "break-all",
          bgcolor: "#16283a",
          border: "1px solid #23394d",
          borderRadius: "9px",
          p: 1.25,
          color: "#9ed1f2",
        }}
      >
        {secretCode || "…"}
      </Typography>
    </Box>
  );
};

export default MfaSetup;
